import request from '../../../requestInstance';
import { CommonResult } from '../../CommonType';
import type {
  InternalNoticeImageUploadResponse,
  InternalNoticeItem,
  InternalNoticeReadStatusItem,
  InternalNoticeSaveRequest,
  InternalNoticeTargetRoleItem,
} from './types';

export async function listPublishedInternalNotices() {
  return request<CommonResult<InternalNoticeItem[]>>('/api/internal-notices/notices/published', {
    method: 'GET',
  });
}

export async function getInternalNoticeUnreadCount() {
  return request<CommonResult<number>>('/api/internal-notices/notices/unread-count', {
    method: 'GET',
  });
}

export async function getInternalNoticeDetail(noticeId: number) {
  return request<CommonResult<InternalNoticeItem>>(`/api/internal-notices/notices/${noticeId}`, {
    method: 'GET',
  });
}

export async function listManageInternalNotices() {
  return request<CommonResult<InternalNoticeItem[]>>('/api/internal-notices/notices/manage', {
    method: 'GET',
  });
}

export async function listInternalNoticeReadStatus(noticeId: number) {
  return request<CommonResult<InternalNoticeReadStatusItem[]>>(
    `/api/internal-notices/notices/${noticeId}/read-status`,
    {
      method: 'GET',
    },
  );
}

export async function listInternalNoticeTargetRoles() {
  return request<CommonResult<InternalNoticeTargetRoleItem[]>>('/api/internal-notices/roles', {
    method: 'GET',
  });
}

export async function uploadInternalNoticeImage(file: File) {
  const formData = new FormData();
  formData.append('file', file);
  return request<CommonResult<InternalNoticeImageUploadResponse>>(
    '/api/internal-notices/images/upload',
    {
      method: 'POST',
      data: formData,
      timeout: 30000,
    },
  );
}

export async function createInternalNotice(data: InternalNoticeSaveRequest) {
  return request<CommonResult<InternalNoticeItem>>('/api/internal-notices/notices/create', {
    method: 'POST',
    data,
  });
}

export async function updateInternalNotice(data: InternalNoticeSaveRequest) {
  return request<CommonResult<InternalNoticeItem>>('/api/internal-notices/notices/update', {
    method: 'PUT',
    data,
  });
}

export async function deleteInternalNotice(noticeId: number) {
  return request<CommonResult<void>>(`/api/internal-notices/notices/${noticeId}`, {
    method: 'DELETE',
  });
}

export async function markInternalNoticesRead(noticeIds: number[]) {
  return request<CommonResult<void>>('/api/internal-notices/notices/read', {
    method: 'POST',
    data: { noticeIds },
  });
}
